/**
 * Created by orenm on 11/23/2014.
 */
define(function (require) {
    "use strict";

    var BaseCollection = require("collections/BaseCollection");
    var SnippetModel = require("connection-models/KPsTab/SnippetModel");
    var ApiResources = require("assets/data/apiResources.json");

    var PageSnippetsCollection = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        PageSnippetsCollection = BaseCollection.extend({
            model: SnippetModel,
            resource: _.clone(ApiResources.ConnectionPanel.Page),
            sortByPriority: true,

            comparator: function(model) {
                return [-model.get("priority"), model.get("order")];
            },

            initialize: function (options) {
                var isAuthenticated = LE.sessionManager.isAuthenticated();
                this.originalUrl = isAuthenticated ? this.resource.securedUrl : this.resource.url;
            },

            prioritize: function (activities) {
                this.each(function (model) {
                    model.calculatePriority(activities);
                });

                this.sort();
            },

            _isValidOptions: function (options) {
                var isValid = true;

                if(_.isEmpty(options) || _.isEmpty(options.area) || (_.isEmpty(options.page)) || (_.isEmpty(options.lang))) {
                    LEConnection.logger.error("Failed to initialize collection with these parameters:", "PageSnippetsCollection:_initializeResource", options);
                    LEConnection.logger.graph({name:"connection:PageSnippetsCollection:_isValidOptions:fail"});
                    isValid = false;
                }

                return isValid;
            },

            _initializeResource: function (options) {
                if (this._isValidOptions(options)) {
                    this.resource.url = this.originalUrl;
                    this.resource.url = this.resource.url.replace("{area}", options.area);
                    this.resource.url = this.resource.url.replace("{page}", options.page);
                    this.resource.url = this.resource.url.replace("{lang}", options.lang);
                    this.resource.url = this.resource.url.replace("{userId}", options.userId);
                    this.resource.url = this.resource.url.replace("{accountId}", options.accountId);
                }
            },
            fetch: function(options) {
                options = options || {};
                options.isPrioritizable = this.sortByPriority;

                if(this._isValidOptions(options)){
                    this._initializeResource(options);
                    return BaseCollection.prototype.fetch.call(this, options);
                }else{
                    if(options.error){
                        options.error();
                    }
                }
            },

            parse: function(resp){
                LEConnection.logger.debug("PageSnippetsCollection: parse - parsing json per snippet");
                _.each(resp, function(item, i){
                    item.order = i;

                });

                return resp;
            }

        });
    });

    return PageSnippetsCollection;
});
